import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { getFcmTokenByUserToken } from '../../../Store/actions';
import { followSwitching, getChannelDetails } from '../../../Store/actions/channelActions';
import {
  getSharePageQuestions,
  postResponseByToken
} from '../../../Store/actions/customizedShare.action';
import { checkUserExistanceForDoctubeShare } from '../../../Store/actions/doctube.action';
import {
  authenticateUser,
  checkEmail,
  checkMobileNumber,
  getOtpViaCall,
  loginSuccess,
  loginWithEmail,
  otpVerification,
  phoneVerification,
  verifyTheOtp
} from '../../../Store/actions/login.action';
import {
  getAllSpecialities,
  newsignUpEmail,
  signUpEmail
} from '../../../Store/actions/registrationAction';
import { getVaultList } from '../../../Store/actions/vault.action';
import {
  getClientDeviceDetails,
  getLocalStorage,
  isFileAllowed,
  log,
  setLocalStorage
} from '../../../common/common';
import { firebaseUpload } from '../../../common/firebase';
import BackdropComponent from '../../../components/BackdropComponent';
import ConsentModal from '../../../components/banner/ConsentModal';
import useRedirect from '../../../components/customHooks/useRedirect';
import appConfig from '../../../config/config';
import other from '../../../pages/registration/assets/OtherParamedics.svg';
import doctor from '../../../pages/registration/assets/doctor.svg';
import nurse from '../../../pages/registration/assets/nurse.svg';
import pharmacist from '../../../pages/registration/assets/pharmacist.svg';
import Timer from '../../spq/components/Timer';
import SpecialityModal from '../../userProfile/components/modals/SpecialityModal';
import Checkbox from '../FormComponents/Checkbox';
import Dropdown from '../FormComponents/Dropdown';
import FileUpload from '../FormComponents/FileUpload';
import MobileNumber from '../FormComponents/MobileNumber';
import TextArea from '../FormComponents/TextArea';
import TextField from '../FormComponents/TextField';
import { returnLabelName } from './demoJson';
import FormSteps from './doctubeShareComponents/FormSteps';
import StepForms from './doctubeShareComponents/StepForms';
import axios from 'axios';

const {
  socialLinks: { privacyPolicy, termsAndConditions }
} = appConfig;

const LOGIN_EMAIL = 'LOGIN_EMAIL';
const LOGIN_MOBILE = 'LOGIN_MOBILE';
const REGISTRATION = 'REGISTRATION';
const DOCTUBE_SETUP = 'DOCTUBE_SETUP';
let selectedSpecilalities = '';

const FormArea = ({ channel_id, share_type, page_id, gtmTagVariable = '', consent_text = '' }) => {
  const UserRegion = useSelector((state) => state.share.UserRegion);
  const isUserGlobal = UserRegion === 'GT' || UserRegion === 'GL';
  // const [linkSentShow, setLinkSentShow] = useState(false);

  // const handleClose = () => setLinkSentShow(false);
  // const handleShow = () => setLinkSentShow(true);
  const [SelectedSpecialityDet, setSelectedSpecialityDet] = useState('');

  console.log('FORM AREA SHARE TYPE', share_type);
  const dispatch = useDispatch();
  const userRegionState = useSelector((state) => state.share.UserRegion);

  const isGlobalRegion = useMemo(
    () => userRegionState === 'GT' || userRegionState == 'GL',
    [userRegionState]
  );
  console.log('isGlobalRegion', isGlobalRegion);
  const [isd, setIsd] = useState('+91');
  const [screen, setScreen] = useState(LOGIN_MOBILE);
  useEffect(() => {
    setIsd(isGlobalRegion ? '+1' : '+91');
    setScreen(isGlobalRegion ? LOGIN_EMAIL : LOGIN_MOBILE);
  }, [userRegionState]);
  const { redirectTo } = useRedirect();
  const [waitShow, setWaitShow] = useState(false);

  const [email, setEmail] = useState('');
  const [backdrop, setBackdrop] = useState(false);
  const [render, setRender] = useState(false);
  const [speciality_data, set_speciality_data] = useState([]);
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [showotp, setShowotp] = useState(false);
  const [showOtherButton, setShowOtherButton] = useState(false);
  const [isChecked, SetIsChecked] = useState(false);
  const [isConsentChecked, SetIsConsentChecked] = useState(false);
  const [consentModal, setConsentModal] = useState(false);
  const refresh = () => setRender(!render);
  const [showSpecModal, setShowSpecModal] = useState(false);

  const [userInput, setUserInput] = useState({
    name: '',
    phone: '',
    medical_council: '',
    registration_no: '',
    age: '',
    gender: '',
    location: '',
    user_type: isUserGlobal ? '' : 1,
    speciality: ''
  });
  const [registrationDetails, setRegistrationDetails] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    pin: ''
  });
  const [shareFormQuestions, setShareFormQuestions] = useState({
    user: [],
    others: []
  });
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [othersInput, setOthersInput] = useState({});
  const [doctubeUser, setDoctubeUser] = useState(false);
  const [nextPrev, setNextPrev] = useState(1);

  const [newUserDetected, setNewUserDetected] = useState(false);
  var doctest = false;
  const showBackdrop = () => !backdrop && setBackdrop(true);
  const hideBackdrop = () => setBackdrop(false);

  const onNewUserDetected = (type) => {
    if (
      type === 'phone' &&
      share_type !== 'training' &&
      share_type !== 'doctube' &&
      share_type !== 'doctube_fst' &&
      share_type !== 'differential_diagnosis'
    ) {
      console.log('new user detected');
      hideBackdrop();
      setNewUserDetected(true);

      fetchSpecialities();

      // setShowotp(true);
    } else {
      onNewUserClick();
    }
  };

  const prefillRegistration = () => {
    setRegistrationDetails((prev) => {
      return {
        ...prev,
        email: email,
        password: password,
        confirmPassword: password
      };
    });
  };
  useEffect(() => {
    // setShowotp(true);
    channel_id != 0 &&
      dispatch(
        getSharePageQuestions(channel_id, (res) => {
          if (res.data) {
            let user = res.data?.user ? res.data?.user?.filter((_q) => _q.visibility != 0) : [];
            let others = res.data?.others
              ? res.data?.others?.filter((_q) => _q.visibility != 0)
              : [];
            log('CHANNEL SHARE QUESTIONS', { user, others });
            setShareFormQuestions({ user, others });
          }
        })
      );

    return () => {
      selectedSpecilalities = '';
    };
  }, [channel_id]);

  const doctubeUserValidation = (token) => {
    console.log('doctube user response of check user', '//access token', token.token);

    dispatch(
      checkUserExistanceForDoctubeShare(token.token, (user) => {
        console.log('doctube user', user);
        setLocalStorage('accessToken', token.token);
        setLocalStorage('refreshToken', token.refresh_token);
        if (user.status_code == 200) {
          console.log('doctube user has account');
          dispatch(
            authenticateUser(token.token, (resp) => {
              if (resp != 'error') {
                if (resp.status_code == 200) {
                  fetchVaultCount();
                  setLocalStorage('user', resp.data);
                  redirectTo('Doctube');
                }
              }
            })
          );
        } else if (user.status_code == 203) {
          dispatch(
            authenticateUser(
              token.token,
              (res) => {
                console.log('callback recived', res);

                if (res.status_code == 200) {
                  setLocalStorage('user', res.data);

                  setUserInput((prev) => {
                    return {
                      ...prev,
                      name:
                        (res.data?.first_name || '') +
                        (res.data?.last_name ? ' ' + res.data?.last_name : '')
                    };
                  });
                  setDoctubeUser(true);
                  setScreen(DOCTUBE_SETUP);
                } else {
                  toast.error('Sorry! Something problem in creating channel');
                }
              },
              share_type
            )
          );
        } else {
          console.log('doctube user has no account');

          // dispatch(
          //   authenticateUser(token.token, (resp) => {
          //     console.log('callback recived', resp);
          //  setLocalStorage('user', resp.data);
          // if (resp != 'error') {
          //   if (resp.status_code == 200) {
          //   } else {
          //     toast.error('Sorry! Something problem in creating channel');
          //   }
          //   setDoctubeUser(true);
          //   setScreen(DOCTUBE_SETUP);
          // }
          //   })
          // );
        }
      })
    );
  };

  const toastMandatory = () => toast.error('Please fill all the mandatory fields');
  const selectSpeciality = (spec, specId) => {
    if (userInput?.speciality?.master_specialities_id !== specId) {
      setUserInput({ ...userInput, speciality: spec });
    }
  };

  const checkKeyPressedMobileNumber = (mobileNo) => {
    let regexMob = /^\d{10}$/;
    let alpanum = /^[a-z0-9]+$/i;
    if (!mobileNo.trim().match(regexMob) && mobileNo.trim().match(alpanum)) {
      toast.error('Please Enter Mobile No in Correct Format');
    } else {
      let formData = new FormData();
      formData.append('phone', mobileNo.trim());

      dispatch(
        checkMobileNumber(formData, (check_response) => {
          if (check_response) {
            const { status_code } = check_response;
            if (status_code == 203) {
              onNewUserDetected('phone');
            } else {
              setNewUserDetected(false);
            }
          } else {
            toast.error('Something Went Wrong');
          }
        })
      );
    }
  };
  const handleUserTextInput = (e) => {
    const { name, value } = e.target;
    if (
      share_type !== 'training' &&
      share_type !== 'doctube' &&
      share_type !== 'doctube_fst' &&
      share_type !== 'differential_diagnosis' &&
      name === 'phone' &&
      value.length === 10 &&
      screen == LOGIN_MOBILE
    ) {
      console.log('PRESSING_KEYS', name, value);
      checkKeyPressedMobileNumber(value);
    }
    setUserInput({
      ...userInput,
      [name]: value
    });
  };
  const handleRegistrationInput = (e) => {
    setRegistrationDetails((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value
      };
    });
  };
  const handleOthersTextInput = (e) => {
    const { name, value } = e.target;
    setOthersInput({
      ...othersInput,
      [name]: value
    });
  };
  const handleCheckboxInput = (e) => {
    const { name, value } = e;
    setOthersInput((prev) => {
      let prevValue = prev[name];
      let prevArr = prevValue?.split(',') ?? [];
      let newArr = [...prevArr, value];
      return {
        ...prev,
        [name]: newArr.join()
      };
    });
  };
  const handleCheckboxUserInput = (e) => {
    const { name, value } = e;
    setUserInput((prev) => {
      let prevValue = prev[name];
      let prevArr = prevValue?.split(',') ?? [];
      let newArr = [...prevArr, value];
      return {
        ...prev,
        [name]: newArr.join()
      };
    });
  };
  const fileUpload = (field_name, _file) => {
    if (['jpg', 'jpeg', 'png', 'pdf'].indexOf(_file?.name?.split('.').pop()) > -1) {
      if (isFileAllowed(_file, 2)) {
        setUploadedFiles({
          ...uploadedFiles,
          [field_name]: _file
        });
      } else {
        toast.error('Please upload a file of below 2 mb');
      }
    } else {
      toast.error('This file format is not supported');
    }
  };
  const cancelUpload = (field_name, _file) => {
    setUploadedFiles({
      ...uploadedFiles,
      [field_name]: null
    });
  };
  const updateSpeciality = () => {
    setShowSpecModal(false);
  };
  const startFileUploadProcess = (userToken) => {
    dispatch(
      getFcmTokenByUserToken(userToken, (firebaseToken) => {
        uploadFileOnebyOne(0, firebaseToken, userToken);
      })
    );
  };

  function uploadFileOnebyOne(index, firebaseToken, userToken) {
    firebaseUpload(
      Object.entries(uploadedFiles)[index][1],
      firebaseToken,
      ['pdf', 'jpg', 'jpeg', 'png'],
      (prog) => {
        console.log('prog', prog);
      },
      (fileUrl) => {
        othersInput[Object.entries(uploadedFiles)[index][0]] = fileUrl;
        index += 1;
        if (index == Object.entries(uploadedFiles)?.length) {
          postUserFieldsResponse(userToken);
        } else {
          uploadFileOnebyOne(index, firebaseToken, userToken);
        }
      },
      () => {
        console.log('error');
      }
    );
  }

  const renderOtherTypeQuestion = (question, index) => {
    const { field_name, type, is_mandatory, options } = question;
    switch (type) {
      case 'text':
      case 'number':
        return (
          <TextField
            label={field_name}
            name={field_name}
            onChange={handleOthersTextInput}
            type="other"
            is_mandatory={is_mandatory}
          />
        );

      case 'textarea':
        return (
          <TextArea
            label={field_name}
            name={field_name}
            onChange={handleOthersTextInput}
            type="other"
            is_mandatory={is_mandatory}
          />
        );
      case 'radio':
        return (
          <Checkbox
            label={field_name}
            options={options}
            idx={index + 'others'}
            type={'radio'}
            onChange={(_g) => handleOthersTextInput({ target: { name: field_name, value: _g } })}
            is_mandatory={is_mandatory}
          />
        );
      case 'checkbox':
        return (
          <Checkbox
            label={field_name}
            options={options}
            idx={index + 'others'}
            type={'checkbox'}
            onChange={(_g) => handleCheckboxInput({ name: field_name, value: _g })}
            is_mandatory={is_mandatory}
          />
        );
      case 'dropdown':
        return (
          <Dropdown
            label={field_name}
            options={options}
            onChange={(_g) => handleOthersTextInput({ target: { name: field_name, value: _g } })}
            is_mandatory={is_mandatory}
          />
        );
      case 'fileupload':
        return (
          <FileUpload
            label={field_name}
            fileUpload={(_file) => fileUpload(field_name, _file)}
            attachedFile={uploadedFiles[field_name]}
            is_mandatory={is_mandatory}
            cancelClick={(_file) => cancelUpload(field_name, _file)}
          />
        );
      default:
        return <></>;
    }
  };
  const renderUserTypeQuestion = (question, index) => {
    const { field_name, type, is_mandatory, options } = question;

    if (field_name == 'phone') {
      return (
        <div className="col-12 shareLoginV2FormRow shareLoginV2MobileNo rounded-3 mt-4 position-relative p-0">
          <MobileNumber
            gtmTagVariable={`${gtmTagVariable}_enterYourMobileNumber`}
            value={userInput.phone}
            onChangeIsd={(_isd) => setIsd(_isd)}
            onChange={handleUserTextInput}
            onKeyPress={(e) => onEnterPress(e, 'login_phone')}
            isGlobalRegion={isGlobalRegion}
          />
        </div>
      );
    } else {
      switch (type) {
        case 'text':
        case 'number':
          return (
            <TextField
              label={returnLabelName(field_name)}
              name={field_name}
              value={userInput[field_name]}
              onChange={handleUserTextInput}
              type="user"
              is_mandatory={is_mandatory}
            />
          );

        case 'textarea':
          return (
            <TextArea
              label={returnLabelName(field_name)}
              name={field_name}
              onChange={handleUserTextInput}
              type="user"
              value={userInput[field_name]}
              is_mandatory={is_mandatory}
            />
          );
        case 'radio':
          return (
            <Checkbox
              label={returnLabelName(field_name)}
              options={options}
              idx={index + 'user'}
              type={'radio'}
              onChange={(_g) => handleUserTextInput({ target: { name: field_name, value: _g } })}
              is_mandatory={is_mandatory}
            />
          );
        case 'checkbox':
          return (
            <Checkbox
              label={returnLabelName(field_name)}
              options={options}
              idx={index + 'user'}
              type={'checkbox'}
              onChange={(_g) => handleCheckboxUserInput({ name: field_name, value: _g })}
              is_mandatory={is_mandatory}
            />
          );
        case 'dropdown':
          return (
            <Dropdown
              label={returnLabelName(field_name)}
              options={options}
              onChange={(_g) => handleUserTextInput({ target: { name: field_name, value: _g } })}
              is_mandatory={is_mandatory}
            />
          );

        default:
          return <></>;
      }
    }
  };
  const checkForMandatoryFields = () => {
    return (
      shareFormQuestions?.user.some((_q) => _q.is_mandatory == 1 && !userInput[_q.field_name]) ||
      shareFormQuestions?.others
        ?.filter((_f) => _f.type != 'fileupload')
        .some((_q) => _q.is_mandatory == 1 && !othersInput[_q.field_name]) ||
      (shareFormQuestions?.others?.filter((_f) => _f.type == 'fileupload')?.length > 0 &&
        shareFormQuestions?.others
          ?.filter((_f) => _f.type == 'fileupload')
          .some((_q) => _q.is_mandatory == 1 && !uploadedFiles[_q.field_name])) ||
      (screen == REGISTRATION && isUserGlobal ? userInput.user_type === '' : false)
    );
  };
  const onEnterPress = (event, type) => {
    if (event.key == 'Enter') {
      if (checkForMandatoryFields()) {
        toastMandatory();
      } else {
        switch (type) {
          case 'login_email':
            loginEmail();
            break;
          case 'login_phone':
            startLoginGetOtp(event, userInput.phone);
            break;
          case 'otp_verify':
            verifyOtp(event, userInput.phone);
            break;
          case 'register':
            startRequestAccessProcess({
              ...registrationDetails,
              phoneNo: userInput.phone,
              fullName: userInput.name
            });
            break;
          default:
            break;
        }
      }
    }
  };
  const ButtonArea = ({ login_state }) => {
    switch (login_state) {
      case LOGIN_MOBILE:
        return !isGlobalRegion ? (
          <>
            <button
              className="w-100 fs-16 fw-medium text-uppercase btn btn-primary rounded-pill mb-3"
              type="button"
              onClick={(e) =>
                checkForMandatoryFields() ? toastMandatory() : startLoginGetOtp(e, userInput.phone)
              }
            >
              Proceed
            </button>
            <button
              className="w-100 fs-16 fw-medium text-uppercase btn btn-secondary rounded-pill"
              type="button"
              onClick={() => setScreen(LOGIN_EMAIL)}
            >
              Login With Email ID
            </button>
          </>
        ) : null;
      case LOGIN_EMAIL:
        return (
          <>
            <button
              className="w-100 fs-16 fw-medium text-uppercase btn btn-primary rounded-pill mb-3"
              type="button"
              onClick={() => {
                checkForMandatoryFields() ? toastMandatory() : loginEmail();
              }}
            >
              Submit
            </button>
            {!isGlobalRegion && (
              <button
                className="w-100 fs-16 fw-medium text-uppercase btn btn-secondary rounded-pill"
                type="button"
                onClick={() => setScreen(LOGIN_MOBILE)}
              >
                Login With Mobile
              </button>
            )}
          </>
        );
      case REGISTRATION:
        return (
          <>
            <button
              className="w-100 fs-16 fw-medium text-uppercase btn btn-primary rounded-pill mb-3"
              type="button"
              onClick={() => {
                checkForMandatoryFields()
                  ? toastMandatory()
                  : startRequestAccessProcess({
                      ...registrationDetails,
                      phoneNo: userInput.phone,
                      fullName: userInput.name
                    });
              }}
            >
              {userRegionState == 'GT' || userRegionState == 'GL' ? 'Register' : 'Request Access'}
            </button>
          </>
        );
      case DOCTUBE_SETUP:
        return <></>;
      default:
        break;
    }
  };
  const fetchSpecialities = () => {
    dispatch(
      getAllSpecialities((res) => {
        if (res != 'error') {
          set_speciality_data(res?.data?.speciality_data ?? []);
        }
      })
    );
  };
  const redirection = (share_type, page_id) => {
    console.log('share type', share_type);
    switch (share_type) {
      case 'comp':
        redirectTo('MedwikiDetails', page_id);
        break;
      case 'session':
        redirectTo('SessionDetails', page_id);
        break;
      case 'gr':
        redirectTo('GrandRoundDetails', page_id);
        break;
      case 'survey':
        redirectTo('SPQdetails', page_id);
        break;
      case 'archived_video':
        redirectTo('ClinicalVideoDetails', page_id);
        break;
      case 'channel':
        redirectTo('ChannelProfile', page_id);
        break;
      case 'training':
        redirectTo('TrainingCover', page_id);
        break;
      case 'differential_diagnosis':
        redirectTo('DifferentialDiagnosis', page_id);
        break;
      case 'epub':
        redirectTo('EbookDetails', page_id);
        break;
      case 'doctube':
        redirectTo('Doctube');
        break;
      default:
        break;
    }
  };
  const checkFullName = () => {
    if (userInput.name) {
      let nameArray = userInput.name.trim().split(' ');
      if (nameArray.length == 1) {
        toast.error('Please Enter Your Last Name');
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  };
  const checkEmailDuplicate = (callback) => {
    let formData = new FormData();
    formData.append('email', email.trim());
    dispatch(
      checkEmail(formData, (res) => {
        if (res.status_code == 200) {
          callback(true);
        } else {
          callback(false);
        }
      })
    );
  };
  const loginEmail = () => {
    log('Proceed Login form');
    if (email == '') {
      toast.error('Please Enter Your Email');
    } else {
      let regexEmail =
        /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;
      if (!email.trim().match(regexEmail)) {
        toast.error('Please Enter a Valid Email');
      } else {
        if (password == '') {
          toast.error('Please Enter Your Password');
        } else {
          if (checkFullName()) {
            showBackdrop();
            checkEmailDuplicate((isEmailAvailable) => {
              if (isEmailAvailable) {
                let formData = new FormData();
                formData.append('email', email.trim());
                formData.append('password', password);
                if (share_type == 'doctube') {
                  formData.append('utm_source', 'doctubeShare');
                } else {
                  getLocalStorage('utm_source', '') &&
                    formData.append('utm_source', getLocalStorage('utm_source', ''));
                }
                dispatch(
                  loginWithEmail(formData, (res) => {
                    if (res != 'error') {
                      log('res', res);
                      if (res.status_code == 203) {
                        hideBackdrop();
                        toast.error(res.message);
                      } else if (res.status_code == 200) {
                        hideBackdrop();
                        if (res.data.status == 3) {
                          if (share_type == 'doctube') {
                            doctubeUserValidation(res.data);
                            // showDoctubeForm();
                          } else {
                            setLocalStorage('accessToken', res.data.token);
                            setLocalStorage('refreshToken', res.data.refresh_token);
                            dispatch(
                              authenticateUser(
                                res.data.token,
                                (resp) => {
                                  if (resp != 'error') {
                                    if (resp.status_code == 200) {
                                      fetchVaultCount();
                                      setLocalStorage('user', resp.data);
                                      Object.keys(uploadedFiles)?.length > 0
                                        ? startFileUploadProcess(res.data.token)
                                        : postUserFieldsResponse(res.data.token);
                                    }
                                  }
                                },
                                share_type
                              )
                            );
                          }
                        } else {
                          toast.error(
                            'This Email is not Registered with us. Please sign up with this email'
                          );
                          // onNewUserClick();

                          onNewUserDetected('email');
                        }
                      } else {
                        hideBackdrop();
                      }
                    } else {
                      hideBackdrop();
                      toast.error('Something Went Wrong');
                    }
                  })
                );
              } else {
                // onNewUserClick();
                onNewUserDetected('email');
              }
            });
          }
        }
      }
    }
  };
  const fetchVaultCount = () => {
    dispatch(
      getVaultList((res) => {
        if (res != 'error') {
          // log("vaultCount", res.data.length);
          if (res.data) {
            setLocalStorage('vaultCount', res.data?.length);
          } else {
            setLocalStorage('vaultCount', 0);
          }
        }
      })
    );
  };
  const postUserFieldsResponse = (token, fromType = '') => {
    if (share_type == 'training' || share_type == 'differential_diagnosis') {
      redirection(share_type, page_id);
    } else {
      dispatch(
        postResponseByToken(token, channel_id, userInput, othersInput, (res) => {
          hideBackdrop();
          if (res != 'error') {
            if (page_id != 0) {
              dispatch(
                getChannelDetails(channel_id, (response) => {
                  if (response?.data[0]?.type_id) {
                    let privacyStatus = response.data[0].privacy_status;
                    let followStatus = response.data[0].followed_status;
                    if (privacyStatus == 0 && followStatus == 0) {
                      dispatch(
                        followSwitching(channel_id, (res) => {
                          redirection(share_type, page_id);
                        })
                      );
                    } else {
                      redirection(share_type, page_id);
                    }
                  }
                })
              );
            }
          }
        })
      );
    }
  };
  const authenticateAndRedirect = (accessToken) => {
    dispatch(
      authenticateUser(
        accessToken,
        (resp) => {
          if (resp != 'error') {
            if (resp.status_code == 200 && share_type != 'doctube') {
              dispatch(
                getVaultList((value_c) => {
                  dispatch(loginSuccess());
                  if (value_c != 'error') {
                    Object.keys(uploadedFiles)?.length > 0
                      ? startFileUploadProcess(accessToken)
                      : postUserFieldsResponse(accessToken);
                    // log("vaultCount", res.data.length);
                    if (value_c.data) {
                      setLocalStorage('vaultCount', value_c.data?.length ?? 0);
                    } else {
                      setLocalStorage('vaultCount', 0);
                    }
                  }
                })
              );
            }
            setLocalStorage('user', resp.data);
          }
        },
        share_type
      )
    );
  };
  const startLoginGetOtp = (e, mobileNo) => {
    e.preventDefault();
    if (mobileNo == '') {
      toast.error('Please Enter Your Mobile No');
    } else {
      let regexMob = /^[0-9]{6,13}$/;
      let alpanum = /^[a-z0-9]+$/i;

      if (!mobileNo.trim().match(regexMob) && mobileNo.trim().match(alpanum)) {
        toast.error('Please Enter Mobile No in Correct Format');
      } else {
        if (checkFullName()) {
          // alert('share_type' + share_type);
          showBackdrop();
          let formData = new FormData();
          formData.append('isdCode', isd);
          formData.append('phone_no', mobileNo.trim());
          getLocalStorage('utm_source', '') &&
            formData.append('utm_source', getLocalStorage('utm_source', ''));
          //for channel one step verification
          if (
            share_type != 'doctube' &&
            share_type != 'doctube_fst' &&
            share_type != 'training' &&
            share_type != 'differential_diagnosis'
          ) {
            if (newUserDetected) {
              if (isChecked) {
                if (consent_text && !isConsentChecked) {
                  toast.error('Please accept the disclaimer');
                  return;
                }
                let formdata = new FormData();
                formdata.append('name', userInput.name);
                formdata.append('phone_no', mobileNo);
                formdata.append('speciality', userInput.speciality?.master_specialities_id);
                formdata.append('page_name', 'channel');
                dispatch(
                  newsignUpEmail(formdata, (new_signup_response) => {
                    if (new_signup_response.status_code == 200) {
                      setLocalStorage('accessToken', new_signup_response?.data.token);
                      setLocalStorage('refreshToken', new_signup_response?.data.refresh_token);
                      authenticateAndRedirect(new_signup_response?.data.token);
                    }
                  })
                );
              } else {
                toast.error('Please accept our terms and conditions');
                hideBackdrop();
              }
            } else {
              dispatch(
                phoneVerification(formData, (phone_ver_resp) => {
                  if (phone_ver_resp.status_code == 200) {
                    setLocalStorage('accessToken', phone_ver_resp.data.token);
                    setLocalStorage('refreshToken', phone_ver_resp.data.refresh_token);
                    authenticateAndRedirect(phone_ver_resp.data.token);
                  }
                })
              );
            }
          } else {
            dispatch(
              otpVerification(formData, (res) => {
                hideBackdrop();
                if (res && res != 'error') {
                  const { status } = res?.data;
                  console.log(status, 'response detected', res);
                  if (status == 0) {
                    onNewUserDetected('phone');
                  } else {
                    setShowotp(true);
                  }
                } else {
                  toast.error('Something Went Wrong');
                }
              })
            );
          }
        }
      }
    }
  };
  const verifyOtp = (e, mobileNo) => {
    e.preventDefault();
    // props?.tracker?.on(CLICK_LOGIN_BUTTON, onLoginButtonClick(props.pageName, mobileNo, ''));

    if (otp == '') {
      toast.error('Please Enter the Otp');
    } else {
      showBackdrop();
      let formData = new FormData();
      formData.append('isdCode', isd);
      formData.append('phone_no', mobileNo.trim());
      formData.append('otp', otp.trim());
      if (share_type == 'doctube') {
        formData.append('utm_source', 'doctubeShare');
      }

      dispatch(
        verifyTheOtp(formData, (res) => {
          log('verified response', res);
          if (res != 'error') {
            if (res.status_code == 203) {
              toast.error(res.message);
              hideBackdrop();
            } else if (res.status_code == 200) {
              console.log('doctube user test', res.data.status);
              hideBackdrop();

              if (res.data.status == 2) {
                /** status 2 for new user  */

                // onNewUserClick();
                onNewUserDetected('phone');
              } else {
                if (res.data.status == 3) {
                  /** status 3 for active user  */

                  if (share_type == 'doctube') {
                    doctubeUserValidation(res.data);
                    // showDoctubeForm();
                  } else {
                    setLocalStorage('accessToken', res.data.token);
                    setLocalStorage('refreshToken', res.data.refresh_token);
                    dispatch(
                      authenticateUser(
                        res.data.token,
                        (resp) => {
                          if (resp != 'error') {
                            if (resp.status_code == 200) {
                              fetchVaultCount();
                              setLocalStorage('user', resp.data);

                              Object.keys(uploadedFiles)?.length > 0
                                ? startFileUploadProcess(res.data.token)
                                : postUserFieldsResponse(res.data.token);
                            }
                          }
                        },
                        share_type
                      )
                    );
                  }
                } else {
                  hideBackdrop();
                  setScreen(isGlobalRegion ? LOGIN_EMAIL : LOGIN_MOBILE);
                  toast.error(
                    'This Mobile is not Registered, Please Use Your Email Id or Register with Us'
                  );
                }
              }
            } else {
              hideBackdrop();
            }
          } else {
            hideBackdrop();
            toast.error('Something Went Wrong');
          }
        })
      );
    }
  };
  const verifyNewUserOtp = (e, mobileNo) => {
    if (!otp) {
      toast.error('Please enter the OTP');
      return;
    }
    if (!userInput.name) {
      toast.error('Please enter your name');
      return;
    }
    if (!checkFullName()) {
      toast.error('Please enter your last name');
      return;
    }
    if (!isChecked) {
      toast.error('Please accept our terms and conditions');
      return;
    }
    if (consent_text && !isConsentChecked) {
      toast.error('Please accept the disclaimer');
      return;
    }
    showBackdrop();
    let formData = new FormData();
    formData.append('isdCode', isd);
    formData.append('phone_no', mobileNo.trim());
    formData.append('otp', otp.trim());
    if (share_type == 'doctube') {
      formData.append('utm_source', 'doctubeShare');
    }

    dispatch(
      verifyTheOtp(formData, (res) => {
        log('verified response', res);
        if (res != 'error') {
          if (res.status_code == 203) {
            toast.error(res.message);
            hideBackdrop();
          } else if (res.status_code == 200) {
            console.log('doctube user test', res.data.status);

            if (res.data.status == 2) {
              let formdata = new FormData();
              formdata.append('name', userInput.name);

              formdata.append('phone_no', mobileNo);

              formdata.append('speciality', userInput.speciality?.master_specialities_id);
              formdata.append('page_name', 'channel');
              dispatch(
                newsignUpEmail(formdata, (response) => {
                  if (response.status_code == 200) {
                    setLocalStorage('accessToken', response?.data.token);
                    setLocalStorage('refreshToken', response?.data.refresh_token);

                    dispatch(
                      authenticateUser(
                        response?.data.token,
                        (resp) => {
                          if (resp != 'error') {
                            if (resp.status_code == 200 && share_type != 'doctube') {
                              dispatch(
                                getVaultList((value_c) => {
                                  dispatch(loginSuccess());
                                  if (value_c != 'error') {
                                    Object.keys(uploadedFiles)?.length > 0
                                      ? startFileUploadProcess(response?.data.token)
                                      : postUserFieldsResponse(response?.data.token);
                                    // log("vaultCount", res.data.length);
                                    if (value_c.data) {
                                      setLocalStorage('vaultCount', value_c.data?.length ?? 0);
                                    } else {
                                      setLocalStorage('vaultCount', 0);
                                    }
                                  }
                                })
                              );
                            }
                            setLocalStorage('user', resp.data);
                          }
                        },
                        share_type
                      )
                    );

                    if (share_type == 'doctube') {
                      setDoctubeUser(true);
                      setScreen(DOCTUBE_SETUP);
                    }
                  } else {
                    if (
                      response.message ==
                        'A user with this Email already exists. Please enter a different Email.' &&
                      response.status_code == 203
                    ) {
                      toast.error(
                        'You have already registered with this email address. Please login to proceed.'
                      );
                      setEmail(registrationDetails.email);
                      setScreen(LOGIN_EMAIL);
                    } else {
                      toast.error(response.message);
                    }
                  }
                })
              );
            }
          } else {
            hideBackdrop();
          }
        } else {
          hideBackdrop();
          toast.error('Something Went Wrong');
        }
      })
    );

    // console.log({ mobileNo, otp, selectedSpecilalities, isChecked });
  };
  const onAgreeConsent = async (userDetails, channel_id, token) => {
    if (consent_text) {
      setLocalStorage('consent_accepted', [channel_id]);
      let mobile_primary = userDetails?.mobile_primary ? userDetails?.mobile_primary : '';
      let device_details = getClientDeviceDetails(mobile_primary);
      let response = await axios({
        baseURL: appConfig.apiLoc,
        url: 'channelnew/channel_to_consent_clicks',
        method: 'POST',
        data: {
          channel_id,
          device_details
        },
        headers: {
          'Content-Type': 'application/json',
          Authorization: token
        }
      });
      console.log('response here:', response);
    }
  };
  const startRequestAccessProcess = (registrationDetails) => {
    let has_error = 0;
    if (registrationDetails.fullName == '') {
      has_error = 1;
      toast.error('Please Enter Your Name');
      return false;
    } else {
      var nameArray = [];
      nameArray = registrationDetails.fullName.trim().split(' ');
      if (nameArray.length == 1) {
        has_error = 1;
        toast.error('Please Enter Your Last Name');
        return false;
      }
    }
    if (registrationDetails.email == '') {
      has_error = 1;
      toast.error('Please Enter email ID');
      return false;
    } else {
      var reEmail =
        /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;
      if (!registrationDetails.email.match(reEmail)) {
        has_error = 1;
        toast.error('Please Enter valid email');
        return false;
      }
    }
    if (registrationDetails.password.trim() == '') {
      has_error = 1;
      toast.error('Please Enter Password');
      return false;
    } else if (registrationDetails.confirmPassword.trim() == '') {
      has_error = 1;
      toast.error('Please Confirm Password');
      return false;
    } else {
      if (registrationDetails.password.trim() != registrationDetails.confirmPassword.trim()) {
        has_error = 1;
        toast.error('Password and confirm password must be same');
        return false;
      }
    }
    // if (registrationDetails.pin == '') {
    //   has_error = 1;
    //   toast.error('Please Enter the Pin Code');
    //   return false;
    // }
    if (!isGlobalRegion) {
      if (registrationDetails.phoneNo == '') {
        has_error = 1;
        toast.error('Please Enter a Mobile Number');
        return false;
      } else {
        let regexMob = /^\d{10}$/;
        let alpanum = /^[a-z0-9]+$/i;
        if (
          !registrationDetails.phoneNo.match(regexMob) &&
          registrationDetails.phoneNo.match(alpanum)
        ) {
          has_error = 1;
          toast.error('Please Enter Mobile No in Correct Format');
          return false;
        }
      }
    }

    if (!isChecked) {
      has_error = 1;
      toast.error('Please accept our terms and conditions');
      return false;
    }
    if (consent_text && !isConsentChecked) {
      has_error = 1;
      toast.error('Please accept the disclaimer');
      return false;
    }
    if (has_error == 0) {
      showBackdrop();
      let formdata = new FormData();
      formdata.append('name', registrationDetails.fullName);
      formdata.append('email', registrationDetails.email);
      formdata.append('phone_no', registrationDetails.phoneNo);
      formdata.append('password', registrationDetails.password);
      formdata.append('confirm_password', registrationDetails.confirmPassword);
      formdata.append('pin', registrationDetails?.pin ? registrationDetails?.pin : '000000');
      formdata.append('speciality', userInput.speciality?.master_specialities_id);
      if (
        share_type != 'doctube' &&
        share_type != 'doctube_fst' &&
        share_type != 'training' &&
        share_type != 'differential_diagnosis'
      ) {
        formdata.append('page_name', 'channel');
      }

      share_type == 'doctube' && formdata.append('page_name', 'doctube');

      if (share_type == 'doctube') {
        formdata.append('utm_source', 'doctubeShare');
      } else {
        getLocalStorage('utm_source', false) &&
          formdata.append('utm_source', getLocalStorage('utm_source', ''));
      }

      dispatch(
        signUpEmail(formdata, (response) => {
          hideBackdrop();
          if (response.status_code == 200) {
            if (share_type == 'training' || share_type == 'differential_diagnosis') {
              setWaitShow(true);
            } else {
              setLocalStorage('accessToken', response?.data.token);
              setLocalStorage('refreshToken', response?.data.refresh_token);
              dispatch(
                authenticateUser(
                  response?.data.token,
                  (resp) => {
                    if (resp != 'error') {
                      setLocalStorage('user', resp.data);
                      onAgreeConsent(resp.data, channel_id, response?.data.token);
                      let toProceed =
                        resp.status_code == 200 && share_type != 'doctube' && resp.data.status == 3;
                      if (toProceed) {
                        dispatch(
                          getVaultList((res) => {
                            dispatch(loginSuccess());
                            if (res != 'error') {
                              Object.keys(uploadedFiles)?.length > 0
                                ? startFileUploadProcess(response?.data.token)
                                : postUserFieldsResponse(response?.data.token);
                              // log("vaultCount", res.data.length);
                              if (res.data) {
                                setLocalStorage('vaultCount', res.data?.length ?? 0);
                              } else {
                                setLocalStorage('vaultCount', 0);
                              }
                            }
                          })
                        );
                      }
                    }
                  },
                  share_type
                )
              );

              if (share_type == 'doctube') {
                setDoctubeUser(true);
                setScreen(DOCTUBE_SETUP);
              }
            }
          } else {
            if (
              response.message ==
                'A user with this Email already exists. Please enter a different Email.' &&
              response.status_code == 203
            ) {
              toast.error(
                'You have already registered with this email address. Please login to proceed.'
              );
              setEmail(registrationDetails.email);
              setScreen(LOGIN_EMAIL);
            } else {
              toast.error(response.message);
            }
          }
        })
      );
    } else {
    }
  };
  console.log('====>>>USER INPUT', userInput);
  const resendOtp = () => {
    setShowOtherButton(false);
    setOtp('');
    let formData = new FormData();
    formData.append('isdCode', isd);
    formData.append('phone_no', userInput.phone.trim());
    dispatch(
      otpVerification(formData, (res) => {
        if (res != 'error') {
          if (res.status_code == 203) {
            toast.error(res.message);
          } else if (res.status_code == 200) {
            log('otp API response', res);
            toast.warn('Otp Sent Again');
          } else {
          }
        } else {
          toast.error('Something Went Wrong');
        }
      })
    );
  };
  const getCall = () => {
    setShowOtherButton(false);
    let formData = new FormData();
    formData.append('isdCode', isd);
    formData.append('phone_no', userInput.phone.trim());
    setOtp('');
    dispatch(
      getOtpViaCall(formData, (res) => {
        if (res != 'error') {
          if (res.status_code == 203) {
            toast.error(res.message);
          } else if (res.status_code == 200) {
            toast.warn('Calling...');
          } else {
          }
        } else {
          toast.error('Something went Wrong');
        }
      })
    );
  };

  const onNewUserClick = () => {
    console.log('on new user click ');
    fetchSpecialities();
    hideBackdrop();
    setShowotp(false);
    setScreen(REGISTRATION);
    prefillRegistration();
    setNewUserDetected(false);
  };
  // console.log('prevNextTab', nextPrev);

  const onNextBtnClick = useCallback(
    (step_no) => {
      setNextPrev(step_no);
      // console.log('prevNextTab inside func', step_no);
      // alert('next btn click' + step_no);
    },
    [nextPrev]
  );
  const CollectSpecialityData = () => {
    return newUserDetected ? (
      <>
        {/* <a
          className="col-12 fs-4 fw-medium cursorPointer text-primary mt-5"
          onClick={() => setShowSpecModal(true)}
        >
          {userInput.speciality != '' && 'specialities_name' in userInput.speciality
            ? `${userInput.speciality?.specialities_name}- Change Speciality`
            : ' + Select Specialities'}
        </a> */}
        <div className="w-100 mt-5 d-flex align-items-center">
          <Form.Check
            id="tnc"
            type={'checkbox'}
            checked={isChecked}
            onChange={() => {
              SetIsChecked(!isChecked);
            }}
            label="I Accept"
          />
          <a
            className="d-inline-block ms-3 text-secondary"
            style={{ verticalAlign: 'top' }}
            target="_blank"
            href={termsAndConditions}
          >
            Terms and Conditions
          </a>
        </div>
        {consent_text && (
          <div className="w-100 mt-5 d-flex align-items-center">
            <Form.Check
              id="consentText"
              type={'checkbox'}
              checked={isConsentChecked}
              onChange={() => {
                SetIsConsentChecked((prev) => !prev);
              }}
              label="I Accept"
            />
            <a
              className="d-inline-block ms-3 text-secondary"
              style={{ verticalAlign: 'top' }}
              target="_blank"
              // href="javascript:void(0)"
              onClick={() => setConsentModal(true)}
            >
              Disclaimer
            </a>
          </div>
        )}
      </>
    ) : null;
  };
  return (
    <>
      <div className="forMbl_shareLoginV2Form w-100 float-start py-20 px-4 py-lg-0 px-lg-0 bg-white rounded-3">
        {doctubeUser && screen == DOCTUBE_SETUP ? (
          <>
            <FormSteps nextPrev={nextPrev} onNextBtnClick={onNextBtnClick} />
          </>
        ) : (
          <>
            <h2 className="fs-3 fw-medium text-black text-center mb-2">
              {screen == REGISTRATION ? 'Sign Up' : 'Login'} Now
            </h2>
            <p className="fs-4 fw-normal text-dark text-center">
              This platform is meant for Registered Medical Practioners only.
            </p>
          </>
        )}

        <div className="w-100 shareLoginV2Form">
          <div className="row mt-n4 mx-0 mb-0">
            {doctubeUser && screen == DOCTUBE_SETUP ? (
              <>
                <StepForms
                  nextPrev={nextPrev}
                  onNextBtnClick={onNextBtnClick}
                  userName={userInput.name}
                />
              </>
            ) : (
              <>
                {screen == LOGIN_EMAIL && (
                  <>
                    <div className="col-12 shareLoginV2FormRow mt-4 position-relative p-0">
                      <TextField
                        className={`${gtmTagVariable}_enterYourMail`}
                        label="Please Enter Your Email"
                        name={'email'}
                        onChange={(_e) => setEmail(_e.target.value)}
                        type="user"
                        is_mandatory={'1'}
                        onKeyPress={(e) => onEnterPress(e, 'login_email')}
                      />
                    </div>
                    <div className="col-12 shareLoginV2FormRow mt-4 position-relative p-0">
                      <TextField
                        className={`${gtmTagVariable}_enterYourPassword`}
                        label="Please Enter Your Password"
                        name={'password'}
                        onChange={(_e) => setPassword(_e.target.value)}
                        type="user"
                        is_mandatory={'1'}
                        onKeyPress={(e) => onEnterPress(e, 'login_email')}
                      />
                    </div>
                  </>
                )}
                {screen == REGISTRATION && (
                  <>
                    {!shareFormQuestions?.user?.some((_q) => _q.field_name == 'name') && (
                      <div className="col-12 shareLoginV2FormRow mt-4 position-relative p-0">
                        <TextField
                          className={`${gtmTagVariable}_enterYourName`}
                          label={returnLabelName('name')}
                          name={'name'}
                          value={userInput.name}
                          onChange={handleUserTextInput}
                          type="user"
                          is_mandatory={'1'}
                        />
                      </div>
                    )}
                    <div className="col-12 shareLoginV2FormRow mt-4 position-relative p-0">
                      <TextField
                        className={`${gtmTagVariable}_enterYourMail`}
                        label="Please Enter Your Email"
                        name={'email'}
                        onChange={handleRegistrationInput}
                        type="user"
                        value={registrationDetails.email}
                        is_mandatory={'1'}
                        onKeyPress={(e) => onEnterPress(e, 'register')}
                      />
                    </div>
                    <div className="col-12 shareLoginV2FormRow mt-4 position-relative p-0">
                      <TextField
                        className={`${gtmTagVariable}_enterYourpassword`}
                        label="Please Enter Your Password"
                        name={'password'}
                        onChange={handleRegistrationInput}
                        type="user"
                        value={registrationDetails.password}
                        is_mandatory={'1'}
                        onKeyPress={(e) => onEnterPress(e, 'register')}
                      />
                    </div>
                    <div className="col-12 shareLoginV2FormRow mt-4 position-relative p-0">
                      <TextField
                        className={`${gtmTagVariable}_enterYourConfirmPassword`}
                        label="Please Confirm Your Password"
                        name={'confirmPassword'}
                        onChange={handleRegistrationInput}
                        value={registrationDetails.confirmPassword}
                        type="user"
                        is_mandatory={'1'}
                        onKeyPress={(e) => onEnterPress(e, 'register')}
                      />
                    </div>
                    {/* <div className="col-12 shareLoginV2FormRow mt-4 position-relative p-0">
                      <TextField
                        className={`${gtmTagVariable}_enterYourPin`}
                        label="Please Enter Your PIN"
                        name={'pin'}
                        onChange={handleRegistrationInput}
                        type="user"
                        value={registrationDetails.pin}
                        is_mandatory={'1'}
                        onKeyPress={(e) => onEnterPress(e, 'register')}
                      />
                    </div> */}
                  </>
                )}
                {showotp && (
                  <>
                    <div className="col-12 shareLoginV2FormRow mt-4 position-relative p-0">
                      <TextField
                        className={`${gtmTagVariable}_enterYourOtp`}
                        label="Please Enter Your OTP"
                        name={'otp'}
                        onChange={(_e) => setOtp(_e.target.value)}
                        type="user"
                        is_mandatory={'1'}
                        onKeyPress={(e) => onEnterPress(e, 'otp_verify')}
                      />
                    </div>
                    {newUserDetected &&
                      !shareFormQuestions?.user?.some((_q) => _q.field_name == 'name') && (
                        <div className="col-12 shareLoginV2FormRow mt-4 position-relative p-0">
                          <TextField
                            className={`${gtmTagVariable}_enterYourName`}
                            label={returnLabelName('name')}
                            name={'name'}
                            value={userInput.name}
                            onChange={handleUserTextInput}
                            type="user"
                            is_mandatory={'1'}
                          />
                        </div>
                      )}
                    <CollectSpecialityData />
                  </>
                )}
                {!showotp && (
                  <>
                    {shareFormQuestions?.user?.length > 0 ? (
                      shareFormQuestions?.user?.map((_qus, _idx) => (
                        <div
                          className="col-12 shareLoginV2FormRow mt-4 position-relative p-0"
                          key={_idx + 1}
                        >
                          {renderUserTypeQuestion(_qus, _idx)}
                        </div>
                      ))
                    ) : screen != LOGIN_EMAIL && !isGlobalRegion ? (
                      <div className="col-12 shareLoginV2FormRow shareLoginV2MobileNo mt-4 position-relative p-0">
                        <MobileNumber
                          gtmTagVariable={`${gtmTagVariable}_enterYourMobileNumber`}
                          value={userInput.phone}
                          onChangeIsd={(_isd) => setIsd(_isd)}
                          onChange={handleUserTextInput}
                          isGlobalRegion={isGlobalRegion}
                          onKeyPress={(e) => onEnterPress(e, 'login_phone')}
                        />
                      </div>
                    ) : null}
                    {shareFormQuestions?.others?.length > 0
                      ? shareFormQuestions?.others?.map((_qus, _idx) => (
                          <div
                            className="col-12 shareLoginV2FormRow mt-4 position-relative p-0"
                            key={_idx + 1}
                          >
                            {renderOtherTypeQuestion(_qus, _idx)}
                          </div>
                        ))
                      : null}
                    {newUserDetected &&
                      !shareFormQuestions?.user?.some((_q) => _q.field_name == 'name') && (
                        <div className="col-12 shareLoginV2FormRow mt-4 position-relative p-0">
                          <TextField
                            label={returnLabelName('name')}
                            name={'name'}
                            value={userInput.name}
                            onChange={handleUserTextInput}
                            type="user"
                            is_mandatory={'1'}
                          />
                        </div>
                      )}
                    <CollectSpecialityData />
                  </>
                )}

                {screen == REGISTRATION && (
                  <>
                    {isUserGlobal ? (
                      <div className="col-12 shareLoginFormRow mt-4 position-relative p-0">
                        <p className="fs-4 fw-normal">
                          Select your profession <span className="text-danger">*</span>
                        </p>
                        <div className="row ms-n3 mt-n3 me-0">
                          {[
                            {
                              id: 1,
                              title: 'Doctor',
                              icon: doctor
                            },
                            { id: 11, title: 'Nurse', icon: nurse },
                            { id: 13, title: 'Pharmacist', icon: pharmacist },
                            { id: 12, title: 'Other', icon: other }
                          ].map((_r, _idx) => (
                            <div className="col-6 ps-3 pt-3 pe-0" key={_idx}>
                              <div className="clr_v3_checkbox position-relative overflow-hidden clr_v3_checkbox__specialityCard">
                                <input
                                  type="radio"
                                  name="user_type"
                                  id={`checkbox_${_idx}`}
                                  value={_r.id}
                                  checked={userInput.user_type == _r.id}
                                  onChange={(e) =>
                                    setUserInput({
                                      ...userInput,
                                      user_type: _r.id,
                                      speciality: { master_specialities_id: 0 }
                                    })
                                  }
                                  className="clr_v3_checkbox__input position-absolute start-0 top-0 w-100 h-100 z-3 opacity-0"
                                />
                                <label
                                  for={`checkbox_${_idx}`}
                                  className="clr_v3_checkbox__label position-relative overflow-hidden rounded-3 p-3 border border-105 border-light w-100 h-100"
                                >
                                  <div className="overlay z-1 bg-primary"></div>
                                  <div className="clr_v3_checkbox__content d-flex flex-column justify-conntent-between">
                                    <div className="d-flex align-items-center justify-content-center p-2 clr_v3_checkbox__specialityIcon mb-3">
                                      <img src={_r.icon} alt={_r.title} className="w-100 h-100" />
                                    </div>
                                    <span className="flex-1 mt-auto">{_r.title}</span>
                                  </div>
                                  <div className="clr_v3_checkbox__icon d-flex align-items-center justify-content-center z-2 rounded-circle position-absolute start-50 top-50">
                                    <i className="flaticon-check fs-30"></i>
                                  </div>
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                    {/* {parseInt(userInput.user_type) === 1 && (
                      <a
                        className="col-12 fs-4 fw-medium cursorPointer text-primary mt-5"
                        onClick={() => setShowSpecModal(true)}
                      >
                        {userInput.speciality != '' && 'specialities_name' in userInput.speciality
                          ? `${userInput.speciality.specialities_name}- Change Speciality`
                          : ' + Select Specialities'}
                      </a>
                    )} */}

                    <div className="w-100 mt-5 d-flex align-items-center">
                      <Form.Check
                        id="tnc"
                        type={'checkbox'}
                        className={`${gtmTagVariable}_i_accept`}
                        checked={isChecked}
                        onChange={() => {
                          SetIsChecked(!isChecked);
                        }}
                        label="I Accept"
                      />
                      <a
                        className={`d-inline-block ms-3 text-secondary align-middle ${gtmTagVariable}_terms_conditions`}
                        // style={{ verticalAlign: 'top' }}
                        target="_blank"
                        href={termsAndConditions}
                      >
                        Terms and Conditions
                      </a>
                    </div>

                    {consent_text && (
                      <div className="w-100 mt-5 d-flex align-items-center">
                        <Form.Check
                          id="consentText"
                          type={'checkbox'}
                          checked={isConsentChecked}
                          onChange={() => {
                            SetIsConsentChecked((prev) => !prev);
                          }}
                          label="I Accept"
                        />
                        <a
                          className="d-inline-block ms-3 text-secondary"
                          style={{ verticalAlign: 'top' }}
                          target="_blank"
                          // href="javascript:void(0)"
                          onClick={() => setConsentModal(true)}
                        >
                          Disclaimer
                        </a>
                      </div>
                    )}
                  </>
                )}

                <div className="col-12 shareLoginV2FormRow mt-4 position-relative p-0">
                  {showotp ? (
                    <>
                      <button
                        className={`w-100 fs-16 fw-medium text-uppercase btn btn-primary rounded-pill mb-3 ${gtmTagVariable}_veryfyOtp_proceed`}
                        type="button"
                        onClick={(e) =>
                          newUserDetected
                            ? verifyNewUserOtp(e, userInput.phone)
                            : verifyOtp(e, userInput.phone)
                        }
                      >
                        Proceed
                      </button>
                      <button
                        className={`w-100 fs-16 fw-medium text-uppercase btn btn-secondary rounded-pill mb-3 ${gtmTagVariable}_editPhNumber`}
                        type="button"
                        onClick={() => {
                          setShowotp(false);
                        }}
                      >
                        Edit Mobile Number
                      </button>
                      {showOtherButton ? (
                        <div className="d-flex justify-content-between w-100">
                          <a
                            className={`fs-4 fw-normal cursorPointer ${gtmTagVariable}_resendOtp`}
                            onClick={resendOtp}
                          >
                            Resend Otp
                          </a>
                          <a
                            className={`fs-4 fw-normal cursorPointer ${gtmTagVariable}_getCallInstead`}
                            onClick={getCall}
                          >
                            Get Call Instead
                          </a>
                        </div>
                      ) : (
                        <p className="text-center">
                          <Timer
                            onDuration={(e) => {}}
                            seconds="30"
                            onEnded={() => {
                              setShowOtherButton(true);
                            }}
                          />
                        </p>
                      )}
                    </>
                  ) : (
                    <ButtonArea login_state={screen} />
                  )}
                </div>
                {screen == REGISTRATION ? (
                  <a
                    className={`col-12 fs-4 fw-medium shareLoginV2FormRow text-center cursorPointer text-primary mt-4 position-relative p-0 ${gtmTagVariable}_logInNow`}
                    onClick={() => setScreen(isGlobalRegion ? LOGIN_EMAIL : LOGIN_MOBILE)}
                  >
                    Already registered? Log In now!
                  </a>
                ) : (
                  <a
                    className={`col-12 fs-4 fw-medium shareLoginV2FormRow text-center cursorPointer text-primary ${gtmTagVariable}_requestAccess mt-4`}
                    onClick={onNewUserClick}
                  >
                    New User? Request for access!
                  </a>
                )}
              </>
            )}
          </div>
        </div>
        <ConsentModal
          is_consent_modal={consentModal}
          onHide={() => setConsentModal(false)}
          consent_text={consent_text}
          title="Disclaimer"
          onAgreeConsent={() => {
            SetIsConsentChecked(true);
            setConsentModal(false);
          }}
        />
        {/*speciality modal start */}
        <SpecialityModal
          show={showSpecModal}
          onHide={updateSpeciality}
          submitClick={updateSpeciality}
          speciality_data={speciality_data}
          selectedSpeciality={userInput.speciality}
          selectSpeciality={selectSpeciality}
        />

        <Modal
          className="centerModal"
          size="md"
          centered
          show={waitShow}
          onHide={() => setWaitShow(false)}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header className="position-relative p-4 border-0 mb-1">
            <Modal.Title className="fs-16 text-black fw-semibold">Please Note</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            <form>
              <div className="w-100 centerModalFrm">
                <div className="row mt-n4">
                  <div className="w-100 text-center fw-medium fs-4 my-2 text-black">
                    Your request has been recorded. You shall hear from us shortly.
                  </div>
                  <div className="w-100 text-center fw-medium fs-4 my-2 text-black">
                    *Direct access is restricted in order to allow only Registered Healthcare
                    Professionals to view the content
                  </div>
                  <div className="mt-4 d-flex flex-wrap">
                    <button
                      className={`col-12 fs-16 btn btn-primary py-3 px-4 ${gtmTagVariable}_knowMore`}
                      type="button"
                      onClick={() => {
                        window.location.href = ' https://www.clirnet.com/newly-featured';
                      }}
                      aria-label="Know More"
                    >
                      Know More
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </Modal.Body>
        </Modal>
        <BackdropComponent backdrop={backdrop} />
      </div>
    </>
  );
};

export default memo(FormArea);
